import { lazy, Suspense } from 'react';
import Spinner from './spinner/Spinner';

const lazySuspense = (importFn) => {
  const Component = lazy(importFn);
  return withSuspense(Component);
};

export default lazySuspense;

// Loading component

// Higher Order Component to wrap components with Suspense
const withSuspense = (Component) => {
  const WrappedComponent = (props) => (
    <Suspense fallback={<Spinner />}>
      <Component {...props} />
    </Suspense>
  );

  // Set display name for better debugging
  const componentName = Component.displayName || Component.name || 'Component';
  WrappedComponent.displayName = `withSuspense(${componentName})`;

  return WrappedComponent;
};
